import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
 fetchGooglePlansByPlanId,
 toggleGooglePlanStatus,
 deleteGooglePlan,
} from "./googlePlanService";
import "./GooglePlanListPage.css";


const GooglePlanListPage = () => {
 const { planId } = useParams();
 const location = useLocation();
 const navigate = useNavigate();

 const planName = location.state?.planName || "Subscription Plan";

 const [googlePlans, setGooglePlans] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {

 loadGooglePlans();
 }, []);

 const loadGooglePlans = async () => {

 try {
 const response = await fetchGooglePlansByPlanId(planId);

 setGooglePlans(response.data);
 } catch (error) {
 } finally {
 setLoading(false);
 }
 };

 const handleToggle = async (plan) => {

 try {
 await toggleGooglePlanStatus(plan.id, !plan.active);
 loadGooglePlans();
 } catch (error) {
 }
 };

 const handleDelete = async (id) => {
 const confirmDelete = window.confirm(
 "Are you sure you want to delete this Google Plan?"
 );
 if (!confirmDelete) return;

 try {
 await deleteGooglePlan(id);
 loadGooglePlans();
 } catch (error) {
 }
 };

 return (
 <div className="google-plan-container">
 <div className="header">
 <h2>Google Plans - {planName}</h2>

 <div className="header-buttons">
 <button
 className="back-btn"
 onClick={() => navigate(-1)}
 >
 ← Back
 </button>

 <button
 className="add-btn"
 onClick={() =>
 navigate(`/admin/google-plans/${planId}/create`)
 }
 >
 + Add Google Plan
 </button>
 </div>
 </div>

 {loading ? (
 <p>Loading...</p>
 ) : googlePlans.length === 0 ? (
 <p>No Google Plans Found</p>
 ) : (
 <table className="google-plan-table">
 <thead>
 <tr>
 <th>Product ID</th>
 <th>Base Plan ID</th>
 <th>Offer ID</th>
 <th>Status</th>
 <th>Toggle</th>
 <th>Delete</th>
 </tr>
 </thead>

 <tbody>
 {googlePlans.map((gp) => (
 <tr key={gp.id}>
 <td>{gp.productId}</td>
 <td>{gp.basePlanId}</td>
 <td>{gp.offerId || "-"}</td>

 <td>
 <span
 className={`status ${
 gp.active ? "active" : "inactive"
 }`}
 >
 {gp.active ? "Active" : "Inactive"}
 </span>
 </td>

 <td>
 <button
 className="toggle-btn"
 onClick={() => handleToggle(gp)}
 >
 {gp.active ? "Disable" : "Enable"}
 </button>
 </td>

 <td>
 <button
 className="delete-btn"
 onClick={() => handleDelete(gp.id)}
 >
 Delete
 </button>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 )}
 </div>
 );
};

export default GooglePlanListPage;